<template>
	<div>
		<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
			 x="0px" y="0px"
			 viewBox="0 0 100 100" style="enable-background:new 0 0 100 100;" xml:space="preserve">
<g>
	<g>
		<rect y="30" class="st0" width="100" height="10"/>
	</g>
	<line class="st1" x1="0" y1="40" x2="100" y2="40"/>
</g>
			<g>
	<g>
		<rect class="st0" width="100" height="10"/>
	</g>
				<line class="st1" x1="0" y1="10" x2="100" y2="10"/>
</g>
			<g>
	<g>
		<rect y="60" class="st0" width="100" height="10"/>
	</g>
				<line class="st1" x1="0" y1="70" x2="100" y2="70"/>
</g>
</svg>
	</div>
</template>

<script>
	export default {
		name: "IconMenu"
	}
</script>

<style scoped>
	.st0 {
		fill: #C4C090;
	}

	.st1 {
		fill: none;
		stroke: #42210B;
		stroke-width: 0.5;
		stroke-miterlimit: 10;
	}
</style>